import { Injectable } from '@angular/core';
import { AbstractOrganizationService } from './abstractOrganizationService';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { getPageParams, PageRequest, SpringPage } from '@shared/page';
import { prependIfMissing } from '@shared/utils/strings';

@Injectable({
  providedIn: 'root',
})
export class OrganizationTlsOptionsService extends AbstractOrganizationService {
  constructor(
    protected readonly http: HttpClient,
    auth: AuthService,
  ) {
    super(auth);
  }

  public getTlsOptions(pageRequest: PageRequest): Observable<SpringPage<TlsOptions>> {
    return this.http.get<SpringPage<TlsOptions>>(this.url(), { params: getPageParams(pageRequest) });
  }

  public getTlsOptionsByUid(uid: string): Observable<TlsOptions> {
    return this.http.get<TlsOptions>(this.url(uid));
  }

  public createTlsOptions(data: TlsOptionsData): Observable<TlsOptions> {
    return this.http.post<TlsOptions>(this.url(), data);
  }

  public updateTlsOptions(uid: string, data: TlsOptionsData): Observable<TlsOptions> {
    return this.http.put<TlsOptions>(this.url(uid), data);
  }

  public removeTlsOptions(uid: string) {
    return this.http.delete(this.url(uid));
  }

  override url(path?: string): string {
    return super.url('tls-options') + (path ? prependIfMissing(path, '/') : '');
  }
}

export type TlsOptionsData = {
  name: string;
  minTlsVersion: TlsVersion;
  maxTlsVersion: TlsVersion;
  clientAuthType: ClientAuthType;
  clientAuthCaCerts: string[];
};

export type TlsOptions = TlsOptionsData & {
  uid: string;
};

export const TlsVersions = ['TLS_1.0', 'TLS_1.1', 'TLS_1.2', 'TLS_1.3'] as const;
export type TlsVersion = (typeof TlsVersions)[number];
export const ClientAuthTypes = ['IgnoreCert', 'VerifyClientCertIfGiven', 'RequireAndVerifyClientCert'] as const;
export type ClientAuthType = (typeof ClientAuthTypes)[number];

export type CaCert = {
  pem: string;
  notBefore: string;
  notAfter: string;
  issuer: string;
  subject: string;
};
